<template>
  <div class="mx-auto mt-10 text-black text-2xl">Página não encontrada</div>
</template>
